import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from '@headlessui/react';

ToggleCard.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function ToggleCard(props) {
  const { label, checked, onChange } = props;
  return (
    <Switch.Group>
      <div className={`flex gap-3 items-start p-3 rounded-[10px] border ${
        checked
          ? 'bg-cs-orange-100 border-cs-orange-500'
          : 'bg-gray-50 border-gray-200'
      }`}>
        <Switch
          checked={checked}
          onChange={onChange}
          className={`${
            checked ? 'bg-cs-orange-500' : 'bg-gray-200'
          } relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors`}
        >
          <span
            className={`${
              checked ? 'translate-x-6' : 'translate-x-1'
            } inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform`}
          />
        </Switch>
        <Switch.Label className="cursor-pointer text-base font-semibold leading-snug text-cs-gray-900">
          {label}
        </Switch.Label>
      </div>
    </Switch.Group>
  );
}
